import { render, staticRenderFns } from "./DunningList.vue?vue&type=template&id=675a5852&"
import script from "./DunningList.vue?vue&type=script&lang=js&"
export * from "./DunningList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports